(() => {
  const reveal = () => {
    const elements = document.querySelectorAll('.sannas-reveal:not([data-sannas-motion-ready])');
    if (!elements.length) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
      elements.forEach((element) => {
        element.dataset.sannasMotionReady = 'true';
        element.classList.add('is-visible');
      });
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.14, rootMargin: '0px 0px -6% 0px' }
    );

    elements.forEach((element) => {
      element.dataset.sannasMotionReady = 'true';
      observer.observe(element);
    });
  };

  document.addEventListener('DOMContentLoaded', reveal);
  document.addEventListener('shopify:section:load', reveal);
})();
